import { render } from "./TranslatePageOrDocumentButton.vue?vue&type=template&id=4e0215e9&scoped=true&ts=true"
import script from "./TranslatePageOrDocumentButton.vue?vue&type=script&lang=ts"
export * from "./TranslatePageOrDocumentButton.vue?vue&type=script&lang=ts"

import "./TranslatePageOrDocumentButton.vue?vue&type=style&index=0&id=4e0215e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0215e9"]])

export default __exports__